import { lazy } from "react"
import {
  PARTNER_TRACTOARE_RO_VIEW,
  PARTNERS_LIST_VIEW,
} from "@/features/partners/routes/route-list.ts"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const AllPartnersView = lazy(
  () => import("@/features/partners/views/all-partners-view/all-partners-view"),
)
const TractoareRo = lazy(
  () => import("@/features/partners/views/tractoare-ro/tractoare-ro"),
)
export const partnerRoutes = [
  {
    element: <NoMenuLayout />,
    children: [
      {
        path: PARTNERS_LIST_VIEW,
        element: <AllPartnersView />,
      },
      {
        path: PARTNER_TRACTOARE_RO_VIEW,
        element: <TractoareRo />,
      },
    ],
  },
]

export const PARTNERS_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: partnerRoutes,
  },
]
